module.exports = __webpack_public_path__ + "img/back-icon.fe332dd6.svg";